export default __webpack_public_path__ + "static/media/EmailAddress.2df789ff.svg";